// Centralized role helpers for the frontend.
// Mirrors backend logic in /app/backend/core/auth.py.

const rolesOf = (user) => {
  if (!user) return [];
  const list = new Set();
  if (user.role) list.add(user.role);
  (user.roles || []).forEach((r) => list.add(r));
  return [...list];
};

export const hasRole = (user, role) => rolesOf(user).includes(role);

export const isAdmin = (user) => hasRole(user, 'admin');
export const isManager = (user) => hasRole(user, 'manager');
export const isSupervisor = (user) => hasRole(user, 'supervisor');

/** Divisions a manager is responsible for. */
export const managerDivisions = (user) => {
  if (!isManager(user)) return [];
  const list = new Set(user?.cost_centers || []);
  if (user?.cost_center) list.add(user.cost_center);
  return [...list];
};

/** Can the user perform admin-level actions on the given division? */
export const canManageDivision = (user, costCenter) => {
  if (isAdmin(user)) return true;
  if (isManager(user) && costCenter && managerDivisions(user).includes(costCenter)) return true;
  return false;
};

/** True if the user has the global admin-level UI (admin, OR manager of any division). */
export const hasAdminUI = (user) => isAdmin(user) || isManager(user);

/** True if the user can mark a specific job complete, per backend rules. */
export const canMarkComplete = (user, job) => {
  if (!job) return false;
  if (canManageDivision(user, job.cost_center)) return true;
  if (
    isSupervisor(user)
    && job.status === 'in_progress'
    && (job.assigned_to || []).includes(user?.id)
  ) {
    return true;
  }
  return false;
};
